import { createFileRoute } from '@tanstack/react-router';
import { Unauthenticated } from 'convex/react';
import { lazy } from 'react';
import { LazyComponent as LazyWrapper } from '@/components/ui';

// Lazy load the AuthPage component for sign-up flow
const SignUpPage = lazy(() => import('../template/pages/SignUpPage'));

const AuthSignUpRoute = () => {
  return (
    <Unauthenticated>
      <LazyWrapper>
        <SignUpPage />
      </LazyWrapper>
    </Unauthenticated>
  );
};

export const Route = createFileRoute('/auth/sign-up')({
  loader: async () => {
    const { default: i18n } = await import('../i18n');
    await i18n.loadNamespaces?.(['auth']);
    return null;
  },
  component: AuthSignUpRoute,
});
